import type * as lazyIndex from "./lazyIndex";
import { createLazyComponent, LazyModule, LazyImport, type LazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "PlacesExplore" */ "./lazyIndex"), { name: "PlacesExplore" });

export const PlacesBuildingPage: LazyComponent<{}, unknown, void> = createLazyComponent(lazyModule, m => m.PlacesBuildingPage);

export const lazyPlacesBuildingModule: LazyImport<typeof lazyIndex, LazyModule<typeof lazyIndex>> = new LazyImport(lazyModule, m => m);
